import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { getErrorsMap, languageComputed } from '@cf/core';
import { TranslateService } from '@tolgee/ngx';

@Component({
  selector: 'div[cf-input-error], cf-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf],
})
export class InputErrorComponent {
  translateService = inject(TranslateService);
  @Input() message!: string;

  error = input<ValidationErrors | { custom: string } | null>(null);

  errorMessage = languageComputed(() => {
    const error = this.error();
    if (error) {
      const key = Object.keys(error);
      const value = Object.values(error);
      const firstKey = key.find(Boolean);
      const firstValue = value.find(Boolean);
      if (firstKey === 'custom') {
        return error.custom;
      }
      if (firstKey === 'pattern') {
        return getErrorsMap(this.translateService, firstKey, firstValue);
      }
      return getErrorsMap(this.translateService, firstKey, firstValue);
    }
    return '';
  });
}
